import { ElementRef, Injectable } from '@angular/core';
import { HelperService } from '../../../services/helper.service';

@Injectable({
  providedIn: 'root',
})
export class GreedyHeaderService {
  navigation: any;
  navigationButton: any;
  linksWrapper: any;
  links: any;
  hiddenLinks: any;
  numOfItems = 0;
  totalSpace = 0;
  breakWidths: any[] = [];
  rootRef!: ElementRef;

  constructor(
    private HELPER: HelperService,
  ) { }

  checkCount = 0;
  hasItemsToHide = false;

  setElements(navigation: ElementRef, navigationButton: ElementRef, links: ElementRef, hiddenLinks: ElementRef) {
    this.navigation = navigation.nativeElement;
    this.navigation = navigation.nativeElement;
    this.linksWrapper = links.nativeElement;
    this.hiddenLinks = hiddenLinks.nativeElement;
  }

  check() {
    if (this.checkCount > 20) {
      this.checkCount = 0;
      return;
    }

    const visibleItems: any[] = [];
    this.linksWrapper.childNodes.forEach((item: any) => {
      if (item.nodeType === Node.ELEMENT_NODE && item.className === 'greedy-links') {
        visibleItems.push(item);
      }
    });

    let availableSpace = this.navigation.offsetWidth - 65;
    let visibleLinksWidth = this.linksWrapper.offsetWidth;
    let hiddenFirstItem = this.hiddenLinks?.childNodes[0];
    let hiddenFirstItemWidth = this.hiddenLinks?.childNodes[0]?.offsetWidth || 0;

    if (visibleLinksWidth > availableSpace) {
      const lastItem = visibleItems[visibleItems.length - 1];
      this.hiddenLinks.prepend(lastItem);
      setTimeout(() => {
        this.checkCount++;
        this.check();
      }, 5);

    } else if (availableSpace > visibleLinksWidth + (hiddenFirstItemWidth) && !!hiddenFirstItem) {
      this.linksWrapper.appendChild(hiddenFirstItem);
      setTimeout(() => {
        this.checkCount++;
        this.check();
      }, 5);
    }

    this.hasItemsToHide = !!this.hiddenLinks?.childNodes?.length;

  }

}
